export function  validateNumbersOnly(input: any) {
    return String(input)
      .toLowerCase()
      .match(/^\d+$/);
  };